import { Box, CircularProgress } from "@mui/material";
import { format } from "date-fns";
import VendorCard from "../../components/reusable-components/cards/vendor-card/VendorCard";
import { iFlatEvent } from "../../types/eventTypes";
import CustomNoRowsOverlay from "../../components/reusable-components/no-rows-overlay/NoRowsOverlay";
import "../../components/reusable-components/cards/vendor-card/vendorCard.css";

interface IMobileEventListProps {
	isLoading: boolean;
	queryParams: string;
	eventList: iFlatEvent[];
}

export default function MobileEventList({ isLoading, queryParams, eventList }: IMobileEventListProps) {
	return (
		<>
			<Box className="vender_card_list">
				{!isLoading &&
					!!eventList.length &&
					eventList.map((event) => (
						<VendorCard
							key={event.id}
							eventId={event.id}
							eventName={event.name}
							customerName={event.customerName}
							location={event.city}
							serviceType={event.occasionType}
							providerType={event.serviceType}
							foodTypes={event.kindOfFood.join(", ").trim()}
							budget={event.budget}
							guests={event.guestsCount}
							notificationVendorCardDot={event.showIndicator}
							eventDate={format(new Date(event.eventDate), "dd MMM yyyy") || ""}
							href={`/event-detail/${event.id}?type=${queryParams}`}
							isBudgetFlexible={event.isFlexible}
						/>
					))}
			</Box>
			{isLoading && <CircularProgress size={24} className="buttonProgress" />}

			{!eventList.length && !isLoading && <CustomNoRowsOverlay message="No Events" />}
		</>
	);
}
